export const setupContactForm = () => {
  const form = $("#contact-form")
  const submitBtm = form.find(".submit-btn")
  form.on("submit", function (e) {
    form.find(".alert").remove()
    submitBtm.attr("disabled", "disabled")
    const nameField = form.find('input[name="name"]')
    const emailField = form.find('input[name="email"]')
    const messageField = form.find('textarea[name="message"]')
    const langField = form.find('input[name="lang"]')
    const data = {
      name: nameField.val(),
      email: emailField.val(),
      message: messageField.val(),
      lang: langField.val(),
    }
    const url = "/form"

    $.post(url, data)
      .done(function (res) {
        const message = res.message
        const okEl = '<div class="alert ok"><p>' + message + "</p></div>"
        form.prepend(okEl)
        nameField.val("")
        emailField.val("")
        messageField.val("")
        submitBtm.removeAttr("disabled")
      })
      .catch(function (err) {
        if (err.status === 422) {
          let errors = []

          err.responseJSON.errors.violations.map((error) => {
            errors.push(error.title)
          })
          const content = errors.map((error) => "<p>" + error + "</p>").join("")
          var errorsEl = $('<div class="alert errors">' + content + "</div>")
          form.prepend(errorsEl)
          submitBtm.removeAttr("disabled")
        }
      })
    return false
  })
}
